export const colorPrimary = 'rgb(0, 111, 185)';
export const colorPrimary1 = 'rgb(0, 80, 133)';
export const colorSecondary = 'rgb(211, 223, 243)';
export const colorLight = 'rgb(255, 255, 255)';
export const colorComp = 'rgb(185, 109, 0)';
export const colorGray = 'rgb(134, 134, 134)';
export const colorBlack = '#000';
export const colorError = '#d8000c';

export const breakSmall = 900;



// WEBPACK FOOTER //
// ./src/variables.tsx